/* ============================================================
   NIGHTLEGS — CART DRAWER
   AJAX cart interactions: open/close, add, update, remove
   ============================================================ */

(function() {
  'use strict';

  // Free-gift auto-add: the eBook joins the cart when the wrap hits GIFT_MIN_QTY units.
  // Handles must match the live products exactly; if the gift product doesn't exist
  // (404), the whole feature no-ops silently.
  var GIFT_HANDLE    = 'the-great-sleep-protocol-ebook';
  var TRIGGER_HANDLE = 'nightlegs-support-pair';
  var GIFT_MIN_QTY   = 2;

  // Shopify Markets: /cart.js amounts arrive already converted to the buyer's
  // currency; only the symbol and any shop-currency constants need converting.
  var SHOP_CURRENCY = (window.Shopify && window.Shopify.currency) || {};
  var FX_RATE = parseFloat(SHOP_CURRENCY.rate) || 1;
  var CUR_SYM = { GBP: '£', EUR: '€' }[SHOP_CURRENCY.active] || '$';

  var CartDrawer = {
    drawer:    null,
    overlay:   null,
    body:      null,
    countEl:   null,
    isOpen:    false,
    threshold: 35, // free shipping threshold in dollars
    bump:      null, // order-bump config (set in the Cart Drawer section settings)

    init: function() {
      this.drawer  = document.getElementById('cart-drawer');
      this.overlay = document.getElementById('site-overlay');
      this.body    = document.getElementById('cart-drawer-body');
      this.countEl = document.getElementById('cart-count');

      var bumpEl = document.getElementById('cart-bump-config');
      if (bumpEl) {
        try { this.bump = JSON.parse(bumpEl.textContent); } catch (e) { this.bump = null; }
      }

      if (!this.drawer) return;

      this._bindEvents();
    },

    _bindEvents: function() {
      var self = this;

      // Global open event
      document.addEventListener('cart:open', function() { self.open(); });
      document.addEventListener('cart:close', function() { self.close(); });

      // Close button
      var closeBtn = document.getElementById('cart-drawer-close');
      if (closeBtn) closeBtn.addEventListener('click', function() { self.close(); });

      // Overlay click
      if (this.overlay) {
        this.overlay.addEventListener('click', function() { self.close(); });
      }

      // Escape key
      document.addEventListener('keydown', function(e) {
        if (e.key === 'Escape' && self.isOpen) self.close();
      });

      // Add to cart buttons (delegated)
      document.addEventListener('click', function(e) {
        var btn = e.target.closest('[data-add-to-cart]');
        if (!btn) return;
        e.preventDefault();
        var variantId = btn.dataset.variantId;
        var qty       = parseInt(btn.dataset.qty || '1', 10);
        if (variantId) self.addItem(variantId, qty, btn);
      });

      // Qty change (delegated, inside drawer)
      document.addEventListener('click', function(e) {
        var btn = e.target.closest('.cart-item__qty-btn');
        if (!btn) return;
        var line  = parseInt(btn.dataset.line, 10);
        var delta = parseInt(btn.dataset.delta, 10);
        if (!isNaN(line) && !isNaN(delta)) self.changeQty(line, delta);
      });

      // Remove item (delegated)
      document.addEventListener('click', function(e) {
        var btn = e.target.closest('.cart-item__remove');
        if (!btn) return;
        var line = parseInt(btn.dataset.line, 10);
        if (!isNaN(line)) self.removeItem(line);
      });

      // Checkout button pixel event
      var checkoutBtn = document.getElementById('cart-checkout-btn');
      if (checkoutBtn) {
        checkoutBtn.addEventListener('click', function() {
          if (typeof fbq !== 'undefined') {
            fbq('track', 'InitiateCheckout');
          }
        });
      }
    },

    open: function() {
      if (!this.drawer) return;
      this.isOpen = true;
      this.drawer.classList.add('is-open');
      this.drawer.setAttribute('aria-hidden', 'false');
      if (this.overlay) this.overlay.classList.add('is-active');
      document.body.style.overflow = 'hidden';
      this.refresh();

      // Hide sticky ATC if visible
      var stickyBar = document.getElementById('sticky-atc');
      if (stickyBar) stickyBar.style.opacity = '0';
    },

    close: function() {
      if (!this.drawer) return;
      this.isOpen = false;
      this.drawer.classList.remove('is-open');
      this.drawer.setAttribute('aria-hidden', 'true');
      if (this.overlay) this.overlay.classList.remove('is-active');
      document.body.style.overflow = '';

      // Restore sticky ATC
      var stickyBar = document.getElementById('sticky-atc');
      if (stickyBar) stickyBar.style.opacity = '';
    },

    refresh: function() {
      var self = this;
      this._fetch('/cart.js', {}, 'GET', function(cart) {
        self._render(cart);
        self._updateCount(cart.item_count);
        document.dispatchEvent(new CustomEvent('cart:updated', { detail: cart }));
      });
    },

    addItem: function(variantId, qty, btn) {
      var self = this;

      if (btn) {
        btn.disabled = true;
        var originalText = btn.innerHTML;
        btn.innerHTML = '<span class="spinner"></span>';
      }

      this._fetch('/cart/add.js', {
        items: [{ id: parseInt(variantId, 10), quantity: qty }]
      }, 'POST', function(result) {
        if (btn) {
          btn.innerHTML = originalText;
          btn.disabled = false;
        }

        if (result.status && result.status !== 200) {
          alert(result.description || 'Could not add to cart.');
          return;
        }

        if (typeof fbq !== 'undefined') {
          fbq('track', 'AddToCart', {
            value: result.items ? result.items[0].final_price / 100 : 0,
            currency: SHOP_CURRENCY.active || 'USD',
            content_ids: [variantId],
            content_type: 'product'
          });
        }

        self.open();
      });
    },

    changeQty: function(line, delta) {
      var self = this;
      var itemEl = document.querySelector('[data-line="' + line + '"]');
      var currentQty = itemEl ? parseInt(itemEl.dataset.qty || '1', 10) : 1;
      var newQty = Math.max(0, currentQty + delta);

      this._fetch('/cart/change.js', { line: line, quantity: newQty }, 'POST', function(cart) {
        self._render(cart);
        self._updateCount(cart.item_count);
        document.dispatchEvent(new CustomEvent('cart:updated', { detail: cart }));
      });
    },

    removeItem: function(line) {
      // Removing the gift by hand shouldn't fight the auto-add for the rest of the session.
      var item = this._lastCart && this._lastCart.items[line - 1];
      if (item && item.handle === GIFT_HANDLE) {
        try { sessionStorage.setItem('nlGiftDismissed', '1'); } catch (e) {}
      }
      this.changeQty(line, -9999);
    },

    _render: function(cart, giftSynced) {
      var self = this;
      if (!this.body) return;

      // Reconcile the free gift once per refresh, then re-render with the updated cart.
      if (!giftSynced) {
        return this._syncGift(cart, function(updated) { self._render(updated, true); });
      }
      this._lastCart = cart;

      if (cart.item_count === 0) {
        this.body.innerHTML = this._emptyState();
        if (this.drawer) this.drawer.classList.add('cart-drawer--empty');
        return;
      }
      if (this.drawer) this.drawer.classList.remove('cart-drawer--empty');

      // Compare-at prices come from /products/{handle}.js (cached after first load),
      // because /cart.js line items don't carry compare_at_price.
      this._withComparePrices(cart, function(compareMap) {
        self._renderWithCompare(cart, compareMap);
      });
    },

    // Line-level compare price in cents, or null. Uses the LARGER of the discount's
    // undiscounted price and the compare-at anchor, so the slider keeps the $119.98
    // anchor even when the bundle discount is applied at line level.
    _comparePriceFor: function(item, compareMap) {
      var best = item.original_line_price > item.final_line_price ? item.original_line_price : 0;
      var cap = compareMap[item.variant_id];
      if (cap && cap * item.quantity > Math.max(best, item.final_line_price)) best = cap * item.quantity;
      return best || null;
    },

    _renderWithCompare: function(cart, compareMap) {
      var threshold = parseFloat(document.body.dataset.freeShippingThreshold || '0') * FX_RATE;
      var subtotal  = cart.total_price / 100;
      var remaining = Math.max(0, threshold - subtotal);
      var progress  = Math.min(100, (subtotal / threshold) * 100);

      var html = '';

      // Shipping progress bar
      html += '<div class="cart-shipping-bar">';
      if (remaining > 0) {
        html += '<p class="cart-shipping-bar__text">Add <strong>' + CUR_SYM + remaining.toFixed(2) + '</strong> more for <strong>FREE shipping!</strong></p>';
      } else {
        html += '<p class="cart-shipping-bar__text cart-shipping-bar__text--success">You\'ve unlocked <strong>FREE shipping!</strong></p>';
      }
      html += '<div class="cart-shipping-bar__track"><div class="cart-shipping-bar__fill" style="width:' + progress + '%"></div></div>';
      html += '</div>';

      // Cart-level (automatic order) discounts don't touch final_line_price in /cart.js,
      // so apportion them across lines pro-rata for DISPLAY, or the line shows full price
      // while the total shows the discounted one.
      var itemsSubtotal = 0;
      for (var p = 0; p < cart.items.length; p++) itemsSubtotal += cart.items[p].final_line_price;
      var cartLevelDiscount = Math.max(0, itemsSubtotal - cart.total_price);
      var displayPrices = [];
      var remainingDiscount = cartLevelDiscount;
      for (var a = 0; a < cart.items.length; a++) {
        var lineTotal = cart.items[a].final_line_price;
        var share = (a === cart.items.length - 1)
          ? remainingDiscount
          : Math.round(cartLevelDiscount * lineTotal / (itemsSubtotal || 1));
        share = Math.min(share, lineTotal);
        remainingDiscount -= share;
        displayPrices.push(lineTotal - share);
      }

      // Items — display order is pinned (wraps first, free eBook second, rest after)
      // while each row keeps its REAL cart line number for qty/remove API calls.
      var rows = [];
      for (var i = 0; i < cart.items.length; i++) {
        rows.push({ item: cart.items[i], line: i + 1, displayPrice: displayPrices[i] });
      }
      rows.sort(function(a, b) {
        function rank(r) {
          if (r.item.handle === TRIGGER_HANDLE) return 0;
          if (r.item.handle === GIFT_HANDLE) return 1;
          return 2;
        }
        return rank(a) - rank(b) || a.line - b.line;
      });
      html += '<div class="cart-items">';
      for (var r = 0; r < rows.length; r++) {
        html += this._renderItem(rows[r].item, rows[r].line, compareMap, rows[r].displayPrice);
      }
      html += '</div>';

      // Upsell — only makes sense with a single unit. Once there are 2+ in the cart,
      // "grab 2 / add another" is redundant, so hide it. Never offer it on the bump product.
      var bumpVariantId = this.bump ? this.bump.variantId : null;
      if (cart.item_count === 1 && cart.items[0] && cart.items[0].variant_id !== bumpVariantId) {
        html += '<div class="cart-upsell">';
        html += '<p class="cart-upsell__text"><strong>Most people grab 2</strong> — one for the nightstand, one for travel</p>';
        html += '<button class="cart-upsell__btn btn btn-ghost btn-sm" data-add-to-cart data-variant-id="' + cart.items[0].variant_id + '" data-qty="1">Add another</button>';
        html += '</div>';
      }

      // Order bump (door/safety alarm) — only when configured and not already in the cart.
      if (this.bump && bumpVariantId) {
        var hasBump = false;
        for (var b = 0; b < cart.items.length; b++) {
          if (cart.items[b].variant_id === bumpVariantId) { hasBump = true; break; }
        }
        if (!hasBump) {
          html += '<div class="cart-bump">';
          if (this.bump.image) {
            html += '<div class="cart-bump__img"><img src="' + this.bump.image + '" alt="' + this._escape(this.bump.title) + '" width="56" height="56" loading="lazy"></div>';
          }
          html += '<div class="cart-bump__info">';
          html += '<p class="cart-bump__text">' + this._escape(this.bump.text || this.bump.title) + '</p>';
          html += '<p class="cart-bump__price">' + CUR_SYM + (this.bump.price / 100).toFixed(2) + '</p>';
          html += '</div>';
          html += '<button class="cart-bump__btn btn btn-primary btn-sm" data-add-to-cart data-variant-id="' + bumpVariantId + '" data-qty="1">' + this._escape(this.bump.cta || 'Add') + '</button>';
          html += '</div>';
        }
      }

      this.body.innerHTML = html;

      // Footer (static markup in the section) — update totals + checkout amount
      var totalCompare = 0;
      for (var t = 0; t < cart.items.length; t++) {
        // Same anchor rule as the line items: compare-at when bigger, else undiscounted line price.
        var lineBase = this._comparePriceFor(cart.items[t], compareMap) || cart.items[t].final_line_price;
        if (displayPrices[t] < cart.items[t].final_line_price && lineBase < cart.items[t].final_line_price) {
          lineBase = cart.items[t].final_line_price;
        }
        totalCompare += lineBase;
      }
      var savings = (totalCompare - cart.total_price) / 100;

      var rows = '';
      if (savings > 0) {
        rows += '<div class="cart-totals__row cart-totals__row--savings"><span>Savings</span><span>-' + CUR_SYM + savings.toFixed(2) + '</span></div>';
      }
      if (remaining <= 0) {
        rows += '<div class="cart-totals__row cart-totals__row--shipping"><span>Shipping</span><span class="cart-totals__free">FREE</span></div>';
      } else {
        rows += '<div class="cart-totals__row"><span>Shipping</span><span>Calculated at checkout</span></div>';
      }
      rows += '<div class="cart-totals__row cart-totals__row--total"><span>Total</span><span class="cart-totals__price">' + CUR_SYM + subtotal.toFixed(2) + '</span></div>';

      var totalsEl = document.getElementById('cart-totals-rows');
      if (totalsEl) totalsEl.innerHTML = rows;
      var amountEl = document.getElementById('cart-checkout-amount');
      if (amountEl) amountEl.textContent = CUR_SYM + subtotal.toFixed(2);
    },

    // Resolve (and cache) the gift product's first variant id; null when unavailable.
    _giftVariant: function(callback) {
      var self = this;
      if (this._giftVariantId !== undefined) return callback(this._giftVariantId);
      var root = (window.nightlegs && window.nightlegs.rootUrl) || (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
      fetch(root + 'products/' + GIFT_HANDLE + '.js')
        .then(function(res) { return res.ok ? res.json() : null; })
        .then(function(product) {
          self._giftVariantId = (product && product.variants && product.variants[0]) ? product.variants[0].id : null;
          callback(self._giftVariantId);
        })
        .catch(function() { self._giftVariantId = null; callback(null); });
    },

    _syncGift: function(cart, callback) {
      var self = this;
      this._giftVariant(function(giftVariantId) {
        if (!giftVariantId) return callback(cart);

        // The eBook is a real $20 catalog product; the Buy-X-Get-Y discount makes it free
        // with 2 wraps. Only lines WE auto-added (marked _auto_gift) are auto-managed —
        // a customer who bought the eBook on its own keeps it no matter what.
        var triggerQty = 0, giftLine = null, giftQty = 0, giftIsAuto = false, anyGift = false;
        for (var i = 0; i < cart.items.length; i++) {
          var it = cart.items[i];
          if (it.handle === GIFT_HANDLE) {
            anyGift = true;
            if (it.properties && it.properties._auto_gift) { giftLine = i + 1; giftQty = it.quantity; giftIsAuto = true; }
          } else if (it.handle === TRIGGER_HANDLE) triggerQty += it.quantity;
        }
        var eligible = triggerQty >= GIFT_MIN_QTY;
        var dismissed = false;
        try { dismissed = sessionStorage.getItem('nlGiftDismissed') === '1'; } catch (e) {}

        if (!eligible) {
          try { sessionStorage.removeItem('nlGiftDismissed'); } catch (e) {}
          if (giftIsAuto) return self._fetch('/cart/change.js', { line: giftLine, quantity: 0 }, 'POST', callback);
          return callback(cart);
        }
        if (!anyGift && !dismissed) {
          return self._fetch('/cart/add.js', { items: [{ id: giftVariantId, quantity: 1, properties: { _auto_gift: 'true' } }] }, 'POST', function() {
            self._fetch('/cart.js', {}, 'GET', callback);
          });
        }
        if (giftIsAuto && giftQty > 1) {
          return self._fetch('/cart/change.js', { line: giftLine, quantity: 1 }, 'POST', callback);
        }
        callback(cart);
      });
    },

    _withComparePrices: function(cart, callback) {
      var self = this;
      if (!this._productCache) this._productCache = {};

      var handles = [];
      for (var i = 0; i < cart.items.length; i++) {
        var h = cart.items[i].handle;
        if (h && !this._productCache[h] && handles.indexOf(h) === -1) handles.push(h);
      }

      var root = (window.nightlegs && window.nightlegs.rootUrl) || (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

      Promise.all(handles.map(function(handle) {
        return fetch(root + 'products/' + handle + '.js')
          .then(function(res) { return res.json(); })
          .then(function(product) { self._productCache[handle] = product; })
          .catch(function() { self._productCache[handle] = { variants: [] }; });
      })).then(function() {
        var map = {};
        for (var j = 0; j < cart.items.length; j++) {
          var product = self._productCache[cart.items[j].handle];
          if (!product || !product.variants) continue;
          for (var v = 0; v < product.variants.length; v++) {
            if (product.variants[v].compare_at_price) {
              map[product.variants[v].id] = product.variants[v].compare_at_price;
            }
          }
        }
        callback(map);
      });
    },

    _renderItem: function(item, line, compareMap, displayFinal) {
      // Request a 160px rendition from the CDN — the raw item.image URL is the full-size
      // original (multi-MB for big renders) and was what made the drawer feel slow.
      var imgUrl = item.image ? item.image + (item.image.indexOf('?') > -1 ? '&' : '?') + 'width=160' : '';
      var img = imgUrl ? ('<img src="' + imgUrl + '" alt="' + this._escape(item.title) + '" width="64" height="64" loading="lazy">') : '';
      var variantTitle = item.variant_title && item.variant_title !== 'Default Title' ? ('<p class="cart-item__variant">' + this._escape(item.variant_title) + '</p>') : '';

      var shown = (typeof displayFinal === 'number') ? displayFinal : item.final_line_price;
      var compareLine = this._comparePriceFor(item, compareMap || {});
      // Anchor on the compare-at value when it's the bigger number (matches the PDP cards);
      // fall back to the undiscounted line price when only the order discount applies.
      if (shown < item.final_line_price && (!compareLine || compareLine < item.final_line_price)) {
        compareLine = item.final_line_price;
      }
      var isGift = item.handle === GIFT_HANDLE;
      var shownText = shown === 0 ? '<span class="cart-totals__free">FREE</span>' : CUR_SYM + (shown / 100).toFixed(2);
      var priceHtml = '';
      if (compareLine && compareLine > shown) {
        priceHtml = '<s>' + CUR_SYM + (compareLine / 100).toFixed(2) + '</s>' + shownText;
      } else {
        priceHtml = shownText;
      }

      return (
        '<div class="cart-item" data-line="' + line + '" data-qty="' + item.quantity + '">' +
          '<div class="cart-item__img">' + img + '</div>' +
          '<div class="cart-item__details">' +
            '<p class="cart-item__title">' + this._escape(item.title) + '</p>' +
            variantTitle +
            '<p class="cart-item__price">' + priceHtml + '</p>' +
          '</div>' +
          '<div class="cart-item__controls">' +
            (isGift ? '' :
            '<div class="qty-selector">' +
              '<button class="qty-selector__btn cart-item__qty-btn" data-line="' + line + '" data-delta="-1" aria-label="Decrease quantity" type="button">−</button>' +
              '<span class="qty-selector__input">' + item.quantity + '</span>' +
              '<button class="qty-selector__btn cart-item__qty-btn" data-line="' + line + '" data-delta="1" aria-label="Increase quantity" type="button">+</button>' +
            '</div>') +
            '<button class="cart-item__remove" data-line="' + line + '" aria-label="Remove ' + this._escape(item.title) + ' from cart" type="button">' +
              '<svg width="14" height="14" viewBox="0 0 14 14" fill="none" aria-hidden="true"><path d="M1 1l12 12M13 1L1 13" stroke="currentColor" stroke-width="2" stroke-linecap="round"/></svg>' +
            '</button>' +
          '</div>' +
        '</div>'
      );
    },

    _emptyState: function() {
      return (
        '<div class="cart-empty">' +
          '<div class="cart-empty__icon"><svg width="48" height="48" viewBox="0 0 24 24" fill="none" aria-hidden="true"><path d="M3 3h2l2.4 12.2a1 1 0 0 0 1 .8h8.9a1 1 0 0 0 1-.76L20.5 7H6" stroke="#1A2744" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/><circle cx="9.5" cy="20" r="1.4" fill="#1A2744"/><circle cx="17" cy="20" r="1.4" fill="#1A2744"/></svg></div>' +
          '<p class="cart-empty__title">Your cart is empty</p>' +
          '<p class="cart-empty__sub">Firm, targeted pressure — made for bed.</p>' +
          '<a href="' + (window.nightlegs && window.nightlegs.productUrl || '/collections/all') + '" class="btn btn-primary">Shop NightLegs</a>' +
        '</div>'
      );
    },

    _updateCount: function(count) {
      if (!this.countEl) return;
      this.countEl.textContent = count;
      if (count === 0) {
        this.countEl.classList.add('is-empty');
      } else {
        this.countEl.classList.remove('is-empty');
      }
    },

    _fetch: function(url, data, method, callback) {
      // Prefix with the locale-aware root so Markets locales ('/en-ca/') keep working.
      var root = (window.nightlegs && window.nightlegs.rootUrl) || (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
      if (url.charAt(0) === '/') url = root + url.slice(1);

      var options = {
        method: method,
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }
      };

      if (method !== 'GET' && data) {
        options.body = JSON.stringify(data);
      }

      fetch(url, options)
        .then(function(res) { return res.json(); })
        .then(function(json) { callback(json); })
        .catch(function(err) { console.error('Cart error:', err); });
    },

    _escape: function(str) {
      return String(str)
        .replace(/&/g, '&amp;')
        .replace(/</g, '&lt;')
        .replace(/>/g, '&gt;')
        .replace(/"/g, '&quot;');
    }
  };

  document.addEventListener('DOMContentLoaded', function() {
    CartDrawer.init();
  });

  window.NightLegsCart = CartDrawer;
})();
